import {Brick, registerBrick, Service} from 'olympe';
import {SUBMIT_PR_SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateSubmitPRSharedMemory.brick';

/**
 * This brick adds an entry into the PRs being submitted Set by publishing an event
 * to shared memory with the appropriate PR tag.
 */
export default class AddInPRsBeingSubmitted extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pRTag
     * @param {function()} forwardEvent
     */
    update($, [prTag], [forwardEvent]) {
        Service.publish('submitPRSharedMemory', {topic: SUBMIT_PR_SHARED_MEMORY_TOPICS.PRS_BEING_SUBMITTED_ADD, prTag})
            .then(forwardEvent);
    }
}

registerBrick('0197c5d929c096e0abcd', AddInPRsBeingSubmitted);
